// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"9f5105f5","668":"499fabe4","762":"2173e06c"}[chunkId] + ".js";
};